import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, Clock, Mail, ArrowLeft } from 'lucide-react';
import { LOGO_DARK_BG } from '../../lib/constants';

export default function RegistroPendiente() {
  const location = useLocation();
  const email = location.state?.email;
  const message = location.state?.message
    || 'Tu cuenta fue registrada y está pendiente de aprobación por un administrador. Te avisaremos por correo cuando sea aprobada.';

  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid="registro-pendiente-page">
      <div className="hero-grain relative hidden flex-col justify-between bg-cnib-navy p-12 lg:flex">
        <Link to="/" data-testid="pending-back-home">
          <img src={LOGO_DARK_BG} alt="CNIB" className="h-12 w-auto" />
        </Link>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-orange-500">CNIB Connect</p>
          <h1 className="mt-4 font-heading text-4xl font-extrabold leading-tight text-white xl:text-5xl">
            Un paso más
            <br />
            <span className="text-orange-500">y estarás dentro.</span>
          </h1>
          <p className="mt-5 max-w-md leading-relaxed text-slate-300">
            Nuestro equipo revisa cada nueva solicitud para asegurar la calidad de la comunidad inmobiliaria.
          </p>
        </div>
        <p className="text-xs text-slate-500">© 2026 Cámara Nacional Inmobiliaria de Bolivia</p>
      </div>

      <div className="flex items-center justify-center bg-slate-50 px-4 py-12">
        <div className="w-full max-w-md space-y-6 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 transition-colors hover:text-cnib-blue"
            data-testid="pending-link-home"
          >
            <ArrowLeft className="h-4 w-4" /> Volver al inicio
          </Link>

          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/15 ring-8 ring-emerald-500/5">
            <CheckCircle2 className="h-10 w-10 text-emerald-500" />
          </div>

          <div>
            <h2 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900">
              ¡Registro recibido!
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{message}</p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-100">
                <Clock className="h-5 w-5 text-amber-600" />
              </span>
              <div>
                <p className="text-sm font-bold text-slate-900">En revisión</p>
                <p className="mt-1 text-xs text-slate-500">
                  La aprobación suele tomar entre 24 y 48 horas hábiles.
                </p>
              </div>
            </div>
            <div className="mt-4 flex items-start gap-3 border-t border-slate-100 pt-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cnib-blue/10">
                <Mail className="h-5 w-5 text-cnib-blue" />
              </span>
              <div>
                <p className="text-sm font-bold text-slate-900">
                  Te avisaremos{email ? ` a ${email}` : ''}
                </p>
                <p className="mt-1 text-xs text-slate-500">
                  Recibirás un correo cuando un administrador apruebe tu alta.
                </p>
              </div>
            </div>
          </div>

          <Link
            to="/login"
            className="inline-block w-full rounded-full bg-cnib-navy py-3 text-sm font-bold text-white transition-colors hover:bg-cnib-blue"
            data-testid="pending-cta-login"
          >
            Ir al acceso
          </Link>
        </div>
      </div>
    </div>
  );
}
